<e-dialog [open]="target() !== null" (openChange)="onOpenChange($event)" [title]="text().title">
  <ng-template>
    @if (target(); as target) {
      <div class="bw-confirm">
        <p class="bw-confirm__intro">{{ text().intro }}</p>
        <dl class="bw-confirm__times">
          <dt>{{ text().old }}</dt><dd>{{ target.oldText }}</dd>
          <dt>{{ text().new }}</dt><dd><strong>{{ target.newText }}</strong> <span class="bw-confirm__delta">{{ target.deltaText }}</span></dd>
        </dl>
        @if (target.unsaved) {
          <p class="bw-confirm__hint">{{ text().unsavedHint }}</p>
        }
        <div class="bw-confirm__actions">
          <button eBtn color="elegant" type="button" [disabled]="target.busy" (click)="cancel()">{{ text().cancel }}</button>
          <button eBtn color="primary-75" icon="check" type="button" [disabled]="target.busy" [attr.aria-busy]="target.busy" (click)="confirm()">
            {{ text().confirm }}
          </button>
        </div>
      </div>
    }
  </ng-template>
</e-dialog>
